import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React, { useState, useRef } from 'react';
import { useTour } from '@/contexts/TourContext';
import { Sparkles, RotateCcw } from 'lucide-react';

// Chave usada para registrar que o usuário já visitou o site ao menos uma vez.
// Na primeira visita a chave não existe → botão aparece e a chave é gravada.
// Em visitas subsequentes a chave já existe → botão não aparece.
const FIRST_VISIT_KEY = 'hostvsl_tour_first_visit_seen';

export function TourChecklist() {
  useLanguage();
  const { tourState, startTour, resetAndRestart, showBadge, isActive } = useTour();
  const lockRef = useRef(false);
  const [showResetMenu, setShowResetMenu] = useState(false);

  // Avalia na montagem inicial: se a chave ainda não existe é a primeira visita.
  // Grava imediatamente para que recarregamentos já sejam tratados como "segunda visita".
  const [isFirstVisit] = useState(() => {
    if (localStorage.getItem(FIRST_VISIT_KEY)) return false;
    localStorage.setItem(FIRST_VISIT_KEY, '1');
    return true;
  });

  // Só exibe o botão na primeira visita
  if (!isFirstVisit) return null;

  const handleClick = () => {
    if (lockRef.current) return;

    if (isActive) return;

    if (tourState.status === 'completed' || tourState.status === 'dismissed') {
      setShowResetMenu(prev => !prev);
      return;
    }

    lockRef.current = true;
    startTour();
    setTimeout(() => { lockRef.current = false; }, 500);
  };

  const handleRestart = () => {
    if (lockRef.current) return;
    lockRef.current = true;
    setShowResetMenu(false);
    resetAndRestart();
    setTimeout(() => { lockRef.current = false; }, 500);
  };

  return (
    <div className="relative">
      <button
        onClick={handleClick}
        className="relative w-9 h-9 rounded-full flex items-center justify-center text-muted-foreground hover:text-primary hover:bg-primary/[0.08] transition-colors"
        aria-label={translateInterfaceText("Primeiros passos")}
        title={translateInterfaceText("Primeiros passos")}
      >
        <Sparkles className="h-[18px] w-[18px]" />
        {showBadge && !isActive && (
          <span className="absolute top-1 right-1 w-2.5 h-2.5 rounded-full bg-primary border-2 border-background" />
        )}
      </button>

      {showResetMenu && (
        <>
          <div className="fixed inset-0 z-[50]" onClick={() => setShowResetMenu(false)} />
          <div className="absolute right-0 top-full mt-2 z-[51] w-[200px] rounded-xl border border-border bg-background shadow-lg p-2">
            <button
              onClick={handleRestart}
              className="w-full flex items-center gap-2 px-3 py-2 rounded-lg text-sm text-foreground hover:bg-muted transition-colors"
            >
              <RotateCcw className="h-3.5 w-3.5" />
              {translateInterfaceText("Reiniciar tour")}</button>
          </div>
        </>
      )}
    </div>
  );
}
